module.exports = __webpack_public_path__ + "img/data3-1.dcd638cd.png";